module.exports = __webpack_public_path__ + "static/media/my needs icon (active).202b08c1.svg";